export const workspace = {
  routes: [
    {
      path: "/workspace/library/notification-type",
      component: () => import("../workspace-library-notification-type-view"),
    },
  ],
};
export const management = {
  routes: [
    {
      path: "/management/notification-type",
      component: () => import("../management-library-notification-type-view"),
    },
  ],
};
